import PropTypes from "prop-types"

export default function PeriodSelectorOption({ label, period, value, select }) {
  const className = period === value ? "option selected" : "option"
  return <div className={className} onClick={() => { select(value) }}>{label}</div>
}

PeriodSelectorOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  select: PropTypes.func.isRequired,
  period: PropTypes.string.isRequired,
}
